// Arquivo .js puro, fora da regra do ts-loader (que so casa com .ts/.tsx).
// Com "module": "commonjs" no tsconfig, o TypeScript compila todo import() dinamico
// para um require() sincrono embrulhado em Promise.resolve().then(...) - o webpack
// enxerga isso como uma dependencia SINCRONA e inclui o modulo no bundle principal,
// sem criar um chunk assincrono separado (mesmo com o comentario magico webpackChunkName).
// Deixando o import() aqui, num .js que o webpack processa com seu parser nativo
// (sem passar por ts-loader), o import() e reconhecido de verdade e vira um chunk
// separado, baixado sob demanda quando o modal e aberto.
module.exports.carregarModalLeitorCodigoBarras = function () {
    return import(/* webpackChunkName: "modal-leitor-codigo-barras" */ "./ModalLeitorCodigoBarras")
}
